/* eslint quotes: "off" */
import $ from "jquery";

export const equalHeightAndWidth = () => {
  //Equal Height
  var heightArray = $(".gameplay_btn").map(function () {
    return $(this).height();
  }).get();
  var maxHeight = Math.max.apply(Math, heightArray);
  $(".gameplay_btn").height(maxHeight);

  //Equal Width
  var widthArray = $(".gameplay_btn").map(function () {
    return $(this).width();
  }).get();
  var maxWidth = Math.max.apply(Math, widthArray);
  $(".gameplay_btn").width(maxWidth);
  //Equal Height Carousel Home
  var heightArray = $(".carousel_prize_container").map( function(){
    return  $(this).height();
  }).get();
  var maxHeight = Math.max.apply( Math, heightArray);
  $(".carousel_prize_container").height(maxHeight);
};

export const closeBanner = () => {
  document.getElementById('bonusclose').addEventListener('click', function (e) {
    e.preventDefault();
    this.parentNode.style.display = 'none';
  }, false);
};

export const profileBar = () => {
  //Equal Height
  var totalProgress, progress;
  const circles = document.querySelectorAll('.progress');
  for(var i = 0; i < circles.length; i++) {
    totalProgress = circles[i].querySelector('circle').getAttribute('stroke-dasharray');
    progress = circles[i].parentElement.getAttribute('data-percent');
    circles[i].querySelector('.bar').style['stroke-dashoffset'] = totalProgress * progress / 100 + 502.4;
  }
};

export const chevronDownloop = () => {
  $('.claim_prize_img').animate({'top': '0'}, {
    duration: 350,
    complete: function () {
      $('.claim_prize_img').animate({
        duration: 1000,
        top: '+=375',
        height: '+=50px',
        width: '+=50px'
      });
    }
  });
};

export const openCloseTab = () => {
  // Close open Menu
  $('.mobile-menu__icon').click(function(e) {

    $('.mobile-menu__icon').toggleClass('open');
    $(".mobile-menu__container").toggleClass('open');
  });

  $(".mobile-menu__item").click(function(e){

    if ($(".mobile-menu__icon").hasClass("open")) {
      $(".mobile-menu__icon").removeClass('open');
    }
    if ($(".mobile-menu__container").hasClass("open")) {
      $(".mobile-menu__container").removeClass('open');
    }
  });
};

export const handleLanguageDropdown = () => {
  $('.main-nav .dropdown').click(function() {
    $(this).stop().toggleClass("open");
  });
  $(document).on('click', function(event) {
    var container = $('.main-nav .dropdown');
    if (!container.is(event.target) && container.has(event.target).length === 0) {
      container.removeClass("");
    }
  });
};

export const handleBurger = () => {
  $('.nav__toggle.nav__toggle_burgerMenu').click(function(e) {
    e.preventDefault();
    if (!$('.nav__toggle.nav__toggle_burgerMenu').hasClass( "active")){
      //CLEAN
      $('.nav-dropdown.nav_dropdown_lang').hide(10);
      $('.nav-dropdown.nav_dropdown_burgerMenu').hide(10);
      $('.nav__toggle.nav__toggle_lang').removeClass( "active");
      $('.nav__toggle.nav__toggle_burgerMenu').removeClass( "active");
      $('#nav_dropdown_lang').hide(10);
      $('.black-overlay').hide(10);
      // CLEAN END

      $('.nav__toggle.nav__toggle_burgerMenu').addClass( "active");
      $('.nav-dropdown.nav_dropdown_burgerMenu').show(200);
      $('.black-overlay').show(200);
    }
    else{
      $('.nav__toggle.nav__toggle_burgerMenu').removeClass( "active");
      $('.nav-dropdown.nav_dropdown_burgerMenu').hide(200);
      $('.black-overlay').hide(200);
    }
  });
  $('.black-overlay').click(function() {
    $('.nav__toggle.nav__toggle_burgerMenu').removeClass('active');
    $('.nav__toggle.nav__toggle_lang').removeClass('active');
    $('.black-overlay').hide(200);
    $('#nav_dropdown_user, #nav_dropdown_burgerMenu, #nav_dropdown_notif, #nav_dropdown_lang, #get_started_menu').stop().fadeOut(200);
  });
};

export const pieChartAnimation = (selectorElement, percent) => {
  if(!$(selectorElement).length) {
    return;
  }
  const el = selectorElement;
  const donut = true;
  percent = Math.round(percent);
  if (percent > 100) {
    percent = 100;
  } else if (percent < 0) {
    percent = 0;
  }
  const deg = Math.round(360 * (percent / 100));

  if (percent > 50) {
    $(el + ' .pie').css('clip', 'rect(auto, auto, auto, auto)');
    $(el + ' .right-side').css('transform', 'rotate(180deg)');
  } else {
    $(el + ' .pie').css('clip', 'rect(0, 1em, 1em, 0.5em)');
    $(el + ' .right-side').css('transform', 'rotate(0deg)');
  }
  if (donut) {
    $(el + ' .right-side').css('border-width', '16px');
    $(el + ' .left-side').css('border-width', '16px');
    $(el + ' .shadow').css('border-width', '16px');
  } else {
    $(el + ' .right-side').css('border-width', '1.0em');
    $(el + ' .left-side').css('border-width', '1.0em');
    $(el + ' .shadow').css('border-width', '1.0em');
  }
  $(el + ' .left-side').css('transform', 'rotate(' + deg + 'deg)');
};

export const updateProgressBarGamesWon = (percent) => {
  $('#gamesWon').each(function(i, obj) {
    $(obj).width(percent+"%");
  });
};

export const updateProgressBarAnswersPercent = (percent) => {
  $('#correctAnswers').each(function(i, obj) {
    $(obj).width(percent+"%");
  });
};

export const spinTheWheel = (clicks, degree, num) => {
    //add 1 every click
    clicks ++;

    /*multiply the degree by number of clicks
     generate random number between 1 - 360,
     then add to the new degree*/
    const newDegree = degree * clicks;
    const extraDegree = Math.floor(((6 - (num + 1))*(1/6) + (1/6)) * (360 - 1 + 1)) + 1;
    const totalDegree = newDegree + extraDegree;

    /*let's make the spin btn to tilt every
     time the edge of the section hits
     the indicator*/
    $('#wheel .sec').each(function(){
      let t = $(this);
      let c = 0;
      let n = 700;
      const interval = setInterval(function () {
        c++;
        if (c === n) {
          clearInterval(interval);
        }
        let aoY = t.offset().top;
        $("#txt").html(aoY);

        /*23.7 is the minumum offset number that
         each section can get, in a 30 angle degree.
         So, if the offset reaches 23.7, then we know
         that it has a 30 degree angle and therefore,
         exactly aligned with the spin btn*/
        if (aoY < 23.89){
          $('#spin').addClass('spin');
          setTimeout(function () {
            $('#spin').removeClass('spin');
          }, 100);
        }
      }, 10);
      $('#inner-wheel').css({
        'transform' : 'rotate(' + totalDegree + 'deg)'
      });
    });
  return clicks;
};

export const stopSpinningTheWheel = () => {
  const wheel = $('#inner-wheel');
  const e = wheel.css('transform'); // get the current state
  wheel.css('transform', e);
};

// TODO remove if not needed
// export const autoChooseThemeAnimation = (vueInstance) => {
//   let counter = 0;
//   let previousRandomIndex = 1;
//   let currentRandomIndex = 1;
//   vueInstance.timer = setInterval(function() {
//     counter++;
//     // console.log(`In SelectTheme: counter = ${counter}`);
//     if(vueInstance.isFinalRound) {
//       shuffle(vueInstance.availableThemesHTMLElementIndices, new Date());
//       currentRandomIndex = vueInstance.availableThemesHTMLElementIndices[0] === previousRandomIndex
//                           ? vueInstance.availableThemesHTMLElementIndices[1]
//                           : vueInstance.availableThemesHTMLElementIndices[0];
//       previousRandomIndex = currentRandomIndex;
//       console.log(`currentRandomIndex: ${currentRandomIndex}`);
//       $('.cat-item').removeClass('active');
//       $('.cat-item:nth-child(' + currentRandomIndex + ')').addClass('active');
//       // 6 sec has elapsed, select a theme randomly
//       if (counter === 12) {
//         clearInterval(vueInstance.timer);
//         if (vueInstance.isHomePlayer) {
//           shuffle(vueInstance.availableThemes, new Date());
//           vueInstance.storeSelectedTheme(vueInstance.availableThemes[0]);
//         }
//       }
//     }
//   }, 500);
// };



// WEBPACK FOOTER //
// ./src/common/jQuery.js